import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ReactLenis, useLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { useEffect } from "react";
import { LanguageProvider, useLang } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MobileBar } from "@/components/MobileBar";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Academics from "@/pages/Academics";
import Contact from "@/pages/Contact";

const PageWrap = ({ children }) => (
  <motion.main
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -8 }}
    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.main>
);

const AppRoutes = () => {
  const location = useLocation();
  const { lang } = useLang();
  const lenis = useLenis();

  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, lenis]);

  return (
    <>
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={`${location.pathname}-${lang}`}>
          <Route path="/" element={<PageWrap><Home /></PageWrap>} />
          <Route path="/about" element={<PageWrap><About /></PageWrap>} />
          <Route path="/academics" element={<PageWrap><Academics /></PageWrap>} />
          <Route path="/contact" element={<PageWrap><Contact /></PageWrap>} />
        </Routes>
      </AnimatePresence>
      <Footer />
      <MobileBar />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ReactLenis>
    </LanguageProvider>
  );
}

export default App;
